"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var UpdateIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(UpdateIcon, _React$PureComponent);

  function UpdateIcon() {
    _classCallCheck(this, UpdateIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(UpdateIcon).apply(this, arguments));
  }

  _createClass(UpdateIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["color", "className"]);
      /* eslint-disable max-len */


      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'update-icon')
      }, props), _react.default.createElement("path", {
        fill: color,
        d: "M9.09859645,3.21846456 C9.29859394,2.92746608 9.6995889,2.92746608 9.89858639,3.21846456 L9.89858639,3.21846456 L11.8985613,6.12744933 C12.1465581,6.48744745 11.9115611,7.00044476 11.4995663,7.00044476 L11.4995663,7.00044476 L10.4995788,7.00044476 L10.4995788,7.12544411 C10.4995788,9.45643191 8.90459889,11.4144217 6.747626,11.9684188 C6.11663393,12.1304179 5.49964169,11.6484204 5.49964169,10.9974238 L5.49964169,10.9974238 C5.49964169,10.5214263 5.83963742,10.1434283 6.29663167,10.018429 C7.56661571,9.66943079 8.49960398,8.50643688 8.49960398,7.12544411 L8.49960398,7.12544411 L8.49960398,7.00044476 L7.49961655,7.00044476 C7.08662174,7.00044476 6.8516247,6.48744745 7.09862159,6.12744933 L7.09862159,6.12744933 Z M5.25274479,0.031581239 C5.88373686,-0.130417913 6.49972912,0.351579564 6.49972912,1.00257616 L6.49972912,1.00257616 C6.49972912,1.47857367 6.15973339,1.85557169 5.70373912,1.98157103 C4.4327551,2.33056921 3.49976683,3.49356312 3.49976683,4.87455589 L3.49976683,4.87455589 L3.49976683,4.99955524 L4.50075425,4.99955524 C4.91274907,4.99955524 5.14774611,5.51255255 4.90074922,5.87255067 L4.90074922,5.87255067 L2.90077436,8.78153544 C2.70077687,9.07253392 2.3007819,9.07253392 2.10078441,8.78153544 L2.10078441,8.78153544 L0.100809554,5.87255067 C-0.146187341,5.51255255 0.0888097052,4.99955524 0.500804526,4.99955524 L0.500804526,4.99955524 L1.49979197,4.99955524 L1.49979197,4.87455589 C1.49979197,2.54356809 3.09477192,0.585578339 5.25274479,0.031581239 Z"
      }));
      /* eslint-enable max-len */
    }
  }]);

  return UpdateIcon;
}(_react.default.PureComponent);

exports.default = UpdateIcon;
UpdateIcon.defaultProps = {
  color: 'inherit'
};
UpdateIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string
};